<template>
  <v-container class="submit-workers-dialog col-12 col-md-8">
    <h1 class="workers-title">Workers</h1>
    <p class="description">
      Select workers to submit for the booking
    </p>
    <WorkersSelection
      :showValidationErrors="showValidationErrors"
      :selectedWorkers="selectedWorkersIds"
      @handleSelectedWorkers="setSelectedWorkers"
      @unselectWorker="unselectWorker"
      :workers="isLoadingCandidates ? [] : workers"
      :is-loading="isLoadingCandidates"
    />
  </v-container>
</template>

<script>
import WorkersSelection from "@/components/bookings/WorkersSelection";
import { createNamespacedHelpers } from "vuex";
import { filter } from "lodash";
import { FETCH_AVAILABLE_CANDIDATES } from "@/store/modules/applications/actions";
import { APPLICATION_NAMESPACE } from "@/store/modules/applications";
import {
  GET_IS_FETCHING_AVAILABLE_CANDIDATES,
  GET_AVAILABLE_CANDIDATES
} from "@/store/modules/applications/getters";

const { mapActions: mapActions, mapGetters } = createNamespacedHelpers(
  APPLICATION_NAMESPACE
);
export default {
  name: "SubmitWorkersForBooking",
  components: {
    WorkersSelection
  },
  props: {
    showValidationErrors: Boolean
  },
  data() {
    return {
      isLoading: false,
      selectedWorkersIds: []
    };
  },
  computed: {
    ...mapGetters({
      workers: GET_AVAILABLE_CANDIDATES,
      isLoadingCandidates: GET_IS_FETCHING_AVAILABLE_CANDIDATES
    })
  },
  inject: ["currentBookingId"],
  created() {
    this.fetchWorkersToSubmit(this.currentBookingId);
  },
  methods: {
    ...mapActions({
      fetchWorkersToSubmit: FETCH_AVAILABLE_CANDIDATES
    }),
    setSelectedWorkers(selectedWorkersIds) {
      this.selectedWorkersIds = selectedWorkersIds;
      this.$emit("onChange", this.selectedWorkersIds);
    },
    unselectWorker(selectedWorker) {
      this.selectedWorkersIds = filter(
        this.selectedWorkersIds,
        id => id !== selectedWorker.id
      );
      this.$emit("onChange", this.selectedWorkersIds);
    }
  }
};
</script>
<style lang="scss">
.submit-workers-dialog {
  margin-top: 5rem;

  .workers-title {
    margin-bottom: 0.5rem;
  }
  .description {
    color: $secondary-text;
    font-size: 22px;
  }
}
</style>
